import React from "react";
import PropTypes from "prop-types";
import { Row, Card, CardHeader, CardBody } from "reactstrap";
import Records from "../transfer-table";
import ManualManagement from "../manual-management";
import TooltipButton from "../../../ui/tooltip-button";

const ProposalDetails = ({
  noManual,
  noProposal,
  modified,
  selectedProposalObject,
  selectedProposal,
  currency,
  manualManagement,
  canEdit,
  toggleSelect,
  onClick,
  clientItems,
  addTransfersToProposal,
  selectedTransfer,
}) => {
  return (
    <div>
      {(!noManual || !noProposal) && (
        <Card className="mt-sm-3">
          <CardHeader className="d-flex align-items-center justify-content-between">
            <Row>
              <div className="col-12">
                <h3>
                  {modified || !selectedProposalObject ? (
                    "Propuesta de Conciliación"
                  ) : (
                    <h3>
                      <span className="level-circle selected">
                        <span>{selectedProposal + 1}</span>
                      </span>
                      <span className="selected-text">
                        {selectedProposalObject.tercero}
                        {selectedProposalObject.name && ` - ${selectedProposalObject.name}`}
                      </span>
                    </h3>
                  )}
                </h3>
              </div>
            </Row>
          </CardHeader>
          {!noManual && (
            <CardBody className="row">
              <div className="col-12 mb-4">
                <h4 className="mb-2">Gestión Manual</h4>
              </div>
              <ManualManagement currency={currency} data={manualManagement} canEdit={canEdit} />
            </CardBody>
          )}
          {!noProposal && (
            <CardBody className="row">
              <div className="col-12">
                <h4>Listado de partidas</h4>
              </div>
              <Records
                addTransfersToProposal={addTransfersToProposal}
                showBottomActions={
                  clientItems.filter(x => x.selected).length > 0 || manualManagement.length > 0
                }
                currency={currency}
                data={clientItems}
                toggleSelect={toggleSelect}
                extraToolbarOptions={
                  canEdit ? (
                    <TooltipButton
                      buttonClassName="btn-tool-table"
                      onClick={onClick}
                      iconClassName="icono-plus-filled"
                      tooltipText="Crear una partida"
                    />
                  ) : null
                }
                selectedTransfer={selectedTransfer}
              />
            </CardBody>
          )}
        </Card>
      )}
    </div>
  );
};
ProposalDetails.propTypes = {
  noManual: PropTypes.bool,
  noProposal: PropTypes.bool,
  modified: PropTypes.bool,
  selectedProposalObject: PropTypes.shape({
    tercero: PropTypes.string,
    name: PropTypes.string
  }),
  clientItems: PropTypes.arrayOf(),
  selectedProposal: PropTypes.number,
  currency: PropTypes.string,
  manualManagement: PropTypes.arrayOf(),
  canEdit: PropTypes.bool,
  toggleSelect: PropTypes.func,
  onClick: PropTypes.func,
  addTransfersToProposal: PropTypes.func,
  selectedTransfer: PropTypes.arrayOf()
};
ProposalDetails.defaultProps = {
  noManual: false,
  noProposal: false,
  modified: false,
  selectedProposalObject: {},
  selectedProposal: 0,
  currency: "EUR",
  manualManagement: [],
  clientItems: [],
  canEdit: false,
  toggleSelect: () => {},
  onClick: () => {},
  addTransfersToProposal: () => {},
  selectedTransfer: []
};

export default ProposalDetails;
